module.exports = __webpack_public_path__ + "img/web-project-1.593c9bbe.jpg";